<template>
  <div v-if='customerContact'>
    <ul class="list-group list-group-flush">
      <li class="list-group-item"  v-if='!$parent.hideHeader'>
        <h6> CUSTOMER INFORMATION
          <span class='actionable' @click='showCustInfo = !showCustInfo'>
            <img v-if='showCustInfo' src="static/assets/img/icon-arrow-down.png" class="m-2 float-right" />
            <img v-else src="static/assets/img/icon-arrow-down.png" class="m-2 float-right flip-270" />
          </span>
        </h6>
        <b-collapse v-model='showCustInfo'  id='custInfo'>
          <div class="my-4 mx-1">
            <ul class="list-unstyled lh-2">
              <li v-for='(value,key,index) in customerContact.PhoneNumbers' :key='index'>
                <template v-if='value.length > 0'>
                  <img src="static/assets/img/icon-phone.png" class="mr-2" />
                <a :href='"tel:+" + value' class='unstyled-link'>
                  <strong class="text-primary">{{value | phoneNumber}}</strong>
                </a>
                </template>

              </li>
              <li v-for='(value,key,index) in customerContact.Emails' :key='index'>
                <img src="static/assets/img/icon-mail.png" class="mr-2" />
                <a class='unstyled-link' :href='"mailto:" + value' target="_top">
                  <strong class="text-primary">{{value}}</strong>
                </a>
              </li>
              <li v-if='customerContact.Address'>
                <img src="static/assets/img/icon-map.png" class="mr-2" />
                <a class='unstyled-link' :href='"http://maps.google.com/?q=" + customerContact.Address' target='_blank'>
                  <strong class="text-primary">{{customerContact.Address}}</strong>
                </a>
              </li>
            </ul>
          </div>
        </b-collapse>
      </li>
      <li class="list-group-item" v-if='showCustomerProfile'>
        <h6> PROFILE INFORMATION
          <span class='actionable' @click='showProfileInfo = !showProfileInfo'>
            <img v-if='showProfileInfo' src="static/assets/img/icon-arrow-down.png" class="m-2 float-right" />
            <img v-else src="static/assets/img/icon-arrow-down.png" class="m-2 float-right flip-270" />
          </span>
        </h6>
        <b-collapse v-model='showProfileInfo' id='profileInfo'>
          <div class="my-4 mx-2" v-if='customerProfile'>
            <ul class="list-unstyled lh-2">
              <li v-if='customerProfile.ProfileStatus'>
                <span class="">Profile Status:</span>
                <strong v-if='customerProfile.ProfileStatus'>{{customerProfile.ProfileStatus | splitCamel}}</strong>
              </li>
              <li v-if='customerProfile.DaysInMarket > 0'>
                <span class="">Days In Market:</span>
                <strong v-if='customerProfile.DaysInMarket'>{{customerProfile.DaysInMarket}}</strong>
              </li>
              <li v-if='customerProfile.LeadStatus'>
                <span class="">Lead Status:</span>
                <strong v-if='customerProfile.LeadStatus'> {{customerProfile.LeadStatus}}</strong>
              </li>
              <li>
                <span class="">Last Activity:</span>
                <strong v-if='customerProfile.LastActivity'> {{customerProfile.LastActivity | formatDate("MM/DD/YYYY")}}</strong>
              </li>
              <li>
                <span class="" v-if='customerProfile.LeadSource'>Lead Source:</span>
                <strong v-if='customerProfile.LeadSource'> {{customerProfile.LeadSource}}</strong>
              </li>
            </ul>
          </div>
        </b-collapse>

      </li>
      <div>
        <b-nav tabs fill>
          <b-nav-item v-bind:active="tagCat == 'searches'" v-on:click="filterTags('searches')" title='Searches'>
            Searches
          </b-nav-item>
          <b-nav-item v-bind:active="tagCat == 'demographics'" v-on:click="filterTags('demographics')" title='Demographics'>
            Demographics
          </b-nav-item>
          <b-nav-item v-bind:active="tagCat =='interests'" v-on:click="filterTags('interests')" title='Interests'>
            Interests
          </b-nav-item>
        </b-nav>
        <div class='my-4 mx-2'>
          <customer-searches v-if='tagCat == "searches"' :searches='customerSearches' />
          <customer-demographics v-else-if='tagCat == "demographics"' :demographics="customerDemographics" />
          <customer-interests :interests="customerInterests" v-else-if='tagCat == "interests"' />
        </div>
      </div>
      <li class="list-group-item" v-if='customerVOIs.VOIs && customerVOIs.VOIs.length > 0'>
        <h6> VEHICLES OF INTEREST
          <!-- <span @click='showVehicles = !showVehicles'>
                  <img v-if='showVehicles' src="static/assets/img/icon-arrow-down.png" class="m-2 float-right" />
                  <i v-else class="fa fa-chevron-up m-2 float-right" />
                </span> -->
        </h6>
        <div class="my-4 mx-2">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>In-Stock</th>
                <th>Intensity</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for='(value,key,index) in customerVOIs.VOIs' :key='index'>
                <td>{{value.Vehicle}}</td>
                <td>{{value.InStock}}</td>
                <td>{{value.Intensity}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>

    </ul>
  </div>
</template>

<script>
  import {
    CustomerAPIClient
  } from '../../../lib/data_access/Customer'
  import {
    alphabeticSort
  } from '../../../lib/utilities/index'
  import moment from 'moment';

  import CustomerDemographics from './InfoPanels/CustomerDemographics.vue'
  import CustomerInterests from './InfoPanels/CustomerInterests.vue'
  import CustomerSearches from './InfoPanels/CustomerSearches.vue'
  export default {
    name: 'customerInfo',
    computed: {
      showCustomerProfile: function (){
        let customerProfile = this.customerProfile;
        if(customerProfile.LeadSource || customerProfile.ProfileStatus || customerProfile.LeadStatus || customerProfile.DaysInMarket > 0 || customerProfile.LastActivity){
          return true
        }
        else
        {
          return false
        }
      }
    },
    data() {
      return {
        customerContact: {},
        customerProfile: {},
        customerInterests: {},
        customerDemographics: {},
        customerSearches: {},
        customerVOIs: {},
        showCustInfo: true,
        showProfileInfo: true,
        showVehicles: true,
        tagCat: 'searches',
        tags: []
      }
    },
    components: {
      CustomerDemographics,
      CustomerInterests,
      CustomerSearches
    },
    methods: {
      filterTags: function (tag) {
        let vm = this;
        this.tagCat = tag;
      }
    },
    filters: {
      splitCamel: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace(/([A-Z])/g, ' $1').trim()
      },
      formatDate: function (value, momentFormat) {
        if (!value) return ''
        return moment(String(value)).format(momentFormat)
      },
      phoneNumber: function (value) {
        if (!value) return ''
        let rtnString = value;
        rtnString = rtnString.replace(/[()]/g, '').replace(/[-]/g, '').replace(/\s+/g, '').replace(
          /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/, "$1 $2 $3");
        return rtnString;
      }
    },
    watch: {
      '$parent.assosciatedIds': {
        handler: function (newVal) {
          let custIds = newVal;
          let vm = this;
          CustomerAPIClient.getCustomerContact(custIds).then(function (contactData) {
            //Sort the emails
            if(contactData){
              if(contactData.Emails) contactData.Emails = alphabeticSort(contactData.Emails);
              vm.customerContact = Object.assign({}, contactData);
            }

          })
          CustomerAPIClient.getCustomerProfile(custIds).then(function (profileData) {
            vm.customerProfile = Object.assign({}, profileData);
          })
          CustomerAPIClient.getCustomerInterest(custIds).then(function (interestData) {
            vm.customerInterests = Object.assign({}, interestData)
          })
          CustomerAPIClient.getCustomerDemographics(custIds).then(function (demographicData) {
            vm.customerDemographics = Object.assign({}, demographicData)
          })
          CustomerAPIClient.getCustomerSearches(custIds).then(function (searchData) {
            vm.customerSearches = Object.assign({}, searchData);
          })
          CustomerAPIClient.getCustomerVOIs(custIds).then(function (voiData) {
            vm.customerVOIs = Object.assign({}, voiData);
          })
        },
        deep: true
      }
    },
    created() {
      let vm = this;
      let custIds = vm.$parent.assosciatedIds;

      CustomerAPIClient.getCustomerContact(custIds).then(function (contactData) {
        //Sort the emails
           if(contactData){
              if(contactData.Emails) contactData.Emails = alphabeticSort(contactData.Emails);
              vm.customerContact = Object.assign({}, contactData);
            }
      })
      CustomerAPIClient.getCustomerProfile(custIds).then(function (profileData) {
        vm.customerProfile = Object.assign({}, profileData);
      })
      CustomerAPIClient.getCustomerInterest(custIds).then(function (interestData) {
        vm.customerInterests = Object.assign({}, interestData)
      })
      CustomerAPIClient.getCustomerDemographics(custIds).then(function (demographicData) {
        vm.customerDemographics = Object.assign({}, demographicData)
      })
      CustomerAPIClient.getCustomerSearches(custIds).then(function (searchData) {
        vm.customerSearches = Object.assign({}, searchData);
      })
      CustomerAPIClient.getCustomerVOIs(custIds).then(function (voiData) {
        vm.customerVOIs = Object.assign({}, voiData);
      })
    }
  }

</script>

<style lang='scss' scoped>
  /* Basic & Basic Justified Iconic Tabs */

  .nav.nav-tabs .nav-link {
    color: $blue-lt;
    font-weight: 400; // font-size: 16px;
    // padding-bottom: 4px;
    transition: none;
  }

  .nav-tabs {
    border-bottom: 1px solid $gray-lt;
  }

  .nav-tabs .nav-link {
    border: none;
  }

  .nav-tabs .nav-link.active {
    border-bottom: 5px solid $blue-lt; // border-bottom: 3px solid $blue-lt;
    color: $charcoal;
  }

  @media screen {}

</style>



// WEBPACK FOOTER //
// src/components/CustomerProfile/CustomerInfo/CustomerInfo.vue